module.exports = __webpack_public_path__ + "static/media/SecurityAgenda.b5566ae8.png";